module.exports = __webpack_public_path__ + "static/media/Social Development Bank.e0ba594b.png";